/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Animated Form Labels
		 * 
		 * CSS class must be added in GForms admin on each field that will need to animate.
		 */
		var animateForm = document.querySelectorAll( '.animate-labels' );

		if ( animateForm ) {
			var inputs = document.querySelectorAll( '.animate-labels input' );

			for ( var i = 0; inputs.length > i; i++ ) {
				var input = inputs[i];
				
				input.addEventListener( 'focus', function() {
					if ( this.parentElement.classList.contains( 'ginput_container' ) ) {
						this.parentElement.parentElement.classList.add( 'active' );
					} else {
						this.parentElement.classList.add( 'active' );
					}
				});

				input.addEventListener( 'blur', function() {
					var $this = this;
					
					setTimeout(function() {
						if ( $this.value == '' ) {
							$this.parentElement.parentElement.classList.remove( 'active' );
							$this.parentElement.classList.remove( 'active' );
						}
					}, 100);
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a:not(.linkclicker-ignore)');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}
        
        /**
		 * Placeholder
		 * 
		 * Does the same thing as linkclicker except to placeholder images so that they link to their respective posts
		 */
        var placeholders = document.querySelectorAll('.placeholder');
        
        for ( var i = 0; placeholders.length > i; i++ ) {
			var placeholder = placeholders[i];
            placeholder.style.cursor = 'pointer';

			placeholder.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.parentElement.querySelector('a:not(.linkclicker-ignore');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
                
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

		/**
		 * Detects if element is in viewport
		 * 
		 * @usage
		 * var el = document.querySelector('.home-panes__line');
		 *
		 * window.addEventListener('scroll', function(event) {
		 * 		if (isInViewport(el)) {
		 *			el.classList.add("in-view");
		 *		}
		 * }, false);
		 */
		function isInViewport(elem) {
			var distance = elem.getBoundingClientRect();
			return (
				distance.top >= 0 &&
				distance.left >= 0 &&
				distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				distance.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		};

		// Hides collapsible content only if JS loads
		var collapsibleContents = document.querySelectorAll('.collapsible-row__content--wrapper');
		collapsibleContents.forEach(function(content) {
			content.classList.add('loaded')
		});

		if (window.jQuery) {
			$('.collapsible-row__header').on('click', function() {
				$(this).parent().toggleClass('expanded');
				$(this).siblings('.collapsible-row__content--wrapper').slideToggle(250);
			});

			// Disable form buttons after first click to prevent duplicate submissions
			$('.gform_wrapper form').submit(function() {
				$(this).find('input[type=submit]').addClass('disabled');
			});

			$('.member').click(function() {
                console.log('foo');
                $(this).next('.member-modal').toggle();
            });

            // Hide the member-modal when the close button is clicked
            $('.member-modal__close').click(function() {
                $(this).closest('.member-modal').hide();
            });
		}

		var videoLayouts = document.querySelectorAll('.layout-video-text');

		if (videoLayouts) {
			for ( let videoLayout of videoLayouts ) {
				videoLayout.querySelector(".play-button").addEventListener("click", function(e){
					// Hide the play button
					e.target.style.display = "none";
		
					// Hide video image
					videoLayout.querySelectorAll('.video-photo img')[0].style.display = "none";
					// Show video wrapper
					videoLayout.querySelectorAll('.video-photo .layout-video-text__video')[0].style.display = "block";
					
					// Take element string from data attribute, and insert it as html. This is done
					// to defer the loading of Vimeo's extra crap on page load.
					var src = videoLayout.querySelector('.layout-video-text__video').getAttribute('data-embed');
					var iframe = document.createElement('iframe');
					iframe.setAttribute('src', src + '&autoplay=1');
					iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
					iframe.setAttribute('frameborder', '0');
					iframe.setAttribute('width', '640');
					iframe.setAttribute('height', '360');
					videoLayout.querySelectorAll('.video-photo .layout-video-text__video')[0].appendChild(iframe);

					e.preventDefault();
				});
			}
		}
        
        // hides Amazon pixel so it doesn't create an empty space at the top of each page
        var amazonPixel = document.querySelector('img[src*="star.gif"]');
        amazonPixel.style.height = '0';

	}); // End of load function
	

	// Include ready events here
	window.addEventListener( 'DOMContentLoaded', function() {
		
	});


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
